import moment from 'moment';

export const DATE_FORMAT_SHORT = 'short';
export const DATE_FORMAT_LONG = 'long';
export const DATE_FORMAT_LONG_WITH_TIME = 'longWithTime';
export const DATE_FORMAT_SHORT_WITH_TIME = 'shortWithTime';
export const DATE_FORMAT_LONG_DAY_SHORT_WITH_TIME = 'longWithDayShort';
export const DATE_FORMAT_DAY_MONTH_TIME = 'MMM D, YYYY h:mm A';
export const DATE_FORMAT_MERIDIEM = 'meridiem';
export const DATE_FORMAT_TIME = 'onlytime';
export const DATE_FORMAT_SHORT_YEAR = 'short_year';
export const DATE_FORMAT_YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const DATE_FORMAT_DAY_MONTH_YEAR = 'DD MMM, Y';
export const DATE_FORMAT_NUMERICAL_SHORT_WITH_TIME = 'shortNumericalWithTime';
export const DATE_FORMAT_MONTH_DAY_YEAR = 'MMM D, YYYY'; // Apr 21, 2025
export const DATE_FORMAT_DAY_MONTH_YEAR_LONG = 'D MMM YYYY'; // 21 Apr 2025
export const DATE_FORMAT_FULL_MONTH_DAY_YEAR = 'MMMM D, YYYY'; // April 21, 2025
export const DATE_FORMAT_DAY_FULL_MONTH_YEAR = 'D MMMM YYYY'; // 21 April 2025
export const DATE_FORMAT_SHORT_MONTH_DAY_YEAR = 'M/D/YY'; // 6/6/25
export const DATE_FORMAT_SHORT_DAY_MONTH_DAY_YEAR = 'ddd, MMM D YYYY'; // Mon, Apr 21 2025
export const DATE_FORMAT_FULL_DAY_MONTH_DAY_YEAR = 'dddd, MMMM D YYYY'; // Monday, April 21 2025
export const DATE_FORMAT_SHORT_DAY_MONTH_YEAR = 'ddd, DD MMM YYYY'; // Mon, 21 Apr 2025
export const DATE_FORMAT_SHORT_DAY_DAY_FULL_MONTH_YEAR = 'ddd, DD MMMM YYYY'; // Mon, 21 April 2025
export const DATE_FORMAT_SHORT_DAY_MONTH_SHORT_YEAR = 'ddd, DD MMM YY'; // Mon, 21 Apr 25
export const DATE_FORMAT_SHORT_DAY_FULL_MONTH_SHORT_YEAR = 'ddd, DD MMMM YY'; // Mon, 21 April 25
export const DATE_FORMAT_ISO_SLASHES = 'YYYY/MM/DD'; // 2025/04/21
export const DATE_FORMAT_ISO_DOTS = 'YYYY.MM.DD'; // 2025.04.21
export const DATE_FORMAT_ISO_SPACES = 'YYYY MM DD'; // 2025 04 21
export const DATE_FORMAT_DAY_FIRST_DASHES = 'DD-MM-YYYY'; // 21-04-2025
export const DATE_FORMAT_DAY_FIRST_SLASHES = 'DD/MM/YYYY'; // 21/04/2025
export const DATE_FORMAT_DAY_FIRST_DOTS = 'DD.MM.YYYY'; // 21.04.2025
export const DATE_FORMAT_DAY_FIRST_SPACES = 'DD MM YYYY'; // 21 04 2025
export const DATE_FORMAT_MONTH_FIRST_DASHES = 'MM-DD-YYYY'; // 04-21-2025
export const DATE_FORMAT_MONTH_FIRST_SLASHES = 'MM/DD/YYYY'; // 04/21/2025
export const DATE_FORMAT_MONTH_FIRST_DOTS = 'MM.DD.YYYY'; // 04.21.2025
export const DATE_FORMAT_MONTH_FIRST_SPACES = 'MM DD YYYY'; // 04 21 2025

const validDateFormats = [
  DATE_FORMAT_LONG,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_SHORT_WITH_TIME,
  DATE_FORMAT_LONG_WITH_TIME,
  DATE_FORMAT_LONG_DAY_SHORT_WITH_TIME,
  DATE_FORMAT_MERIDIEM,
  DATE_FORMAT_TIME,
  DATE_FORMAT_SHORT_YEAR,
  DATE_FORMAT_YEAR_MONTH_DAY,
  DATE_FORMAT_DAY_MONTH_YEAR,
  DATE_FORMAT_DAY_MONTH_TIME,
  DATE_FORMAT_NUMERICAL_SHORT_WITH_TIME,
];

export const DATE_TIME_FORMATS = [
  DATE_FORMAT_MONTH_DAY_YEAR,
  DATE_FORMAT_DAY_MONTH_YEAR,
  DATE_FORMAT_FULL_MONTH_DAY_YEAR,
  DATE_FORMAT_SHORT_MONTH_DAY_YEAR,
  DATE_FORMAT_DAY_FULL_MONTH_YEAR,
  DATE_FORMAT_SHORT_DAY_MONTH_DAY_YEAR,
  DATE_FORMAT_FULL_DAY_MONTH_DAY_YEAR,
  DATE_FORMAT_SHORT_DAY_MONTH_YEAR,
  DATE_FORMAT_SHORT_DAY_DAY_FULL_MONTH_YEAR,
  DATE_FORMAT_SHORT_DAY_MONTH_SHORT_YEAR,
  DATE_FORMAT_SHORT_DAY_FULL_MONTH_SHORT_YEAR,
  DATE_FORMAT_DAY_MONTH_YEAR,
  DATE_FORMAT_YEAR_MONTH_DAY,
  DATE_FORMAT_ISO_SLASHES,
  DATE_FORMAT_ISO_DOTS,
  DATE_FORMAT_ISO_SPACES,
  DATE_FORMAT_DAY_FIRST_DASHES,
  DATE_FORMAT_DAY_FIRST_SLASHES,
  DATE_FORMAT_DAY_FIRST_DOTS,
  DATE_FORMAT_DAY_FIRST_SPACES,
  DATE_FORMAT_MONTH_FIRST_DASHES,
  DATE_FORMAT_MONTH_FIRST_SLASHES,
  DATE_FORMAT_MONTH_FIRST_DOTS,
  DATE_FORMAT_MONTH_FIRST_SPACES,
];

export const FormatDateTime = ({ dateTime, format, displayInUTC, displayWithoutConversion }) => {
  if (!dateTime) {
    return '';
  }

  let dateTimeFormat;

  const givenFormat = validDateFormats.includes(format) ? format : DATE_FORMAT_SHORT;

  switch (givenFormat) {
    case DATE_FORMAT_TIME:
      dateTimeFormat = 'HH:mm'; // eg. 14:30
      break;
    case DATE_FORMAT_NUMERICAL_SHORT_WITH_TIME:
      dateTimeFormat = 'HH:mm DD/MM'; // eg. 10:10 25/12
      break;
    case DATE_FORMAT_SHORT_YEAR:
      dateTimeFormat = 'ddd, DD MMM YY'; // eg. SUN , 04 Jun 23
      break;
    case DATE_FORMAT_SHORT:
      dateTimeFormat = 'DD MMM Y'; // eg. 04 Jun 2020
      break;
    case DATE_FORMAT_DAY_MONTH_YEAR:
      dateTimeFormat = 'DD MMM, Y'; // eg. 04 Jun, 2020
      break;
    case DATE_FORMAT_YEAR_MONTH_DAY:
      dateTimeFormat = 'YYYY-MM-DD'; // eg. 2023-10-01
      break;
    case DATE_FORMAT_LONG:
      dateTimeFormat = 'dddd, DD MMMM Y'; // eg. Thursday, 04 June 2020
      break;
    case DATE_FORMAT_DAY_MONTH_TIME:
      dateTimeFormat = 'MMM D, YYYY h:mm A';
      break;
    case DATE_FORMAT_SHORT_WITH_TIME:
      dateTimeFormat = 'HH:mm DD MMM Y'; // eg. 14:30 04 Jun 2020
      break;
    case DATE_FORMAT_LONG_WITH_TIME:
      dateTimeFormat = 'HH:mm dddd, DD MMMM Y'; // eg. 14:30 Thursday, 04 June 2020
      break;
    case DATE_FORMAT_LONG_DAY_SHORT_WITH_TIME:
      dateTimeFormat = 'HH:mm ddd, DD MMMM YY'; // eg. 14:30 Thu, 04 June 20
      break;
    case DATE_FORMAT_MERIDIEM:
      dateTimeFormat = 'LT'; // eg. 2:40 PM
      break;
    case DATE_FORMAT_MONTH_DAY_YEAR:
      dateTimeFormat = 'MMM D, YYYY'; // Apr 21, 2025
      break;
    case DATE_FORMAT_DAY_MONTH_YEAR_LONG:
      dateTimeFormat = 'D MMM YYYY'; // 21 Apr 2025
      break;
    case DATE_FORMAT_FULL_MONTH_DAY_YEAR:
      dateTimeFormat = 'MMMM D, YYYY'; // April 21, 2025
      break;
    case DATE_FORMAT_DAY_FULL_MONTH_YEAR:
      dateTimeFormat = 'D MMMM YYYY'; // 21 April 2025
      break;
    case DATE_FORMAT_SHORT_MONTH_DAY_YEAR:
      dateTimeFormat = 'M/D/YY'; // 6/6/25
      break;
    case DATE_FORMAT_SHORT_DAY_MONTH_DAY_YEAR:
      dateTimeFormat = 'ddd, MMM D YYYY'; // Mon, Apr 21 2025
      break;
    case DATE_FORMAT_FULL_DAY_MONTH_DAY_YEAR:
      dateTimeFormat = 'dddd, MMMM D YYYY'; // Monday, April 21 2025
      break;
    case DATE_FORMAT_SHORT_DAY_MONTH_YEAR:
      dateTimeFormat = 'ddd, DD MMM YYYY'; // Mon, 21 Apr 2025
      break;
    case DATE_FORMAT_SHORT_DAY_DAY_FULL_MONTH_YEAR:
      dateTimeFormat = 'ddd, DD MMMM YYYY'; // Mon, 21 April 2025
      break;
    case DATE_FORMAT_SHORT_DAY_MONTH_SHORT_YEAR:
      dateTimeFormat = 'ddd, DD MMM YY'; // Mon, 21 Apr 25
      break;
    case DATE_FORMAT_SHORT_DAY_FULL_MONTH_SHORT_YEAR:
      dateTimeFormat = 'ddd, DD MMMM YY'; // Mon, 21 April 25
      break;
    case DATE_FORMAT_ISO_SLASHES:
      dateTimeFormat = 'YYYY/MM/DD'; // 2025/04/21
      break;
    case DATE_FORMAT_ISO_DOTS:
      dateTimeFormat = 'YYYY.MM.DD'; // 2025.04.21
      break;
    case DATE_FORMAT_ISO_SPACES:
      dateTimeFormat = 'YYYY MM DD'; // 2025 04 21
      break;
    case DATE_FORMAT_DAY_FIRST_DASHES:
      dateTimeFormat = 'DD-MM-YYYY'; // 21-04-2025
      break;
    case DATE_FORMAT_DAY_FIRST_SLASHES:
      dateTimeFormat = 'DD/MM/YYYY'; // 21/04/2025
      break;
    case DATE_FORMAT_DAY_FIRST_DOTS:
      dateTimeFormat = 'DD.MM.YYYY'; // 21.04.2025
      break;
    case DATE_FORMAT_DAY_FIRST_SPACES:
      dateTimeFormat = 'DD MM YYYY'; // 21 04 2025
      break;
    case DATE_FORMAT_MONTH_FIRST_DASHES:
      dateTimeFormat = 'MM-DD-YYYY'; // 04-21-2025
      break;
    case DATE_FORMAT_MONTH_FIRST_SLASHES:
      dateTimeFormat = 'MM/DD/YYYY'; // 04/21/2025
      break;
    case DATE_FORMAT_MONTH_FIRST_DOTS:
      dateTimeFormat = 'MM.DD.YYYY'; // 04.21.2025
      break;
    case DATE_FORMAT_MONTH_FIRST_SPACES:
      dateTimeFormat = 'MM DD YYYY'; // 04 21 2025
      break;
    default:
      break;
  }

  if (displayWithoutConversion) {
    return moment
      .parseZone(dateTime)
      .locale(I18n.locale)
      .format(dateTimeFormat);
  } else if (displayInUTC) {
    return moment(dateTime)
      .utc()
      .locale(I18n.locale)
      .format(dateTimeFormat);
  }

  return moment(dateTime)
    .locale(I18n.locale)
    .format(dateTimeFormat);
};

export const getDateTimeFormatOptions = (dateTime = moment()) =>
  DATE_TIME_FORMATS.map(format => ({
    label: dateTime.format(format),
    value: format,
  }));

export default FormatDateTime;
